module.exports = __webpack_public_path__ + "img/html.a7931782.svg";